import { jsx, jsxs } from "react/jsx-runtime";
import { Activity, Airplay } from "@tamagui/lucide-icons";
import { Button, Group, ListItem, Separator, XGroup, YGroup, YStack } from "tamagui";
function GroupDemo() {
  return /* @__PURE__ */ jsxs(YStack, { padding: "$3", space: "$2", alignItems: "center", children: [
    /* @__PURE__ */ jsxs(Group, { axis: "horizontal", children: [
      /* @__PURE__ */ jsx(Group.Item, { children: /* @__PURE__ */ jsx(Button, { children: "First" }) }),
      /* @__PURE__ */ jsx(Group.Item, { children: /* @__PURE__ */ jsx(Button, { children: "Second" }) }),
      /* @__PURE__ */ jsx(Group.Item, { children: /* @__PURE__ */ jsx(Button, { children: "Third" }) })
    ] }),
    /* @__PURE__ */ jsxs(XGroup, { size: "$3", $gtSm: { size: "$5" }, children: [
      /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(Button, { size: "$3", icon: Activity, children: "First" }) }),
      /* @__PURE__ */ jsx(XGroup.Item, { children: /* @__PURE__ */ jsx(Button, { size: "$3", icon: Airplay, children: "Second" }) })
    ] }),
    /* @__PURE__ */ jsxs(YGroup, { separator: /* @__PURE__ */ jsx(Separator, {}), children: [
      /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { title: "First" }) }),
      /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { title: "Second", subTitle: "Second subtitle" }) }),
      /* @__PURE__ */ jsx(YGroup.Item, { children: /* @__PURE__ */ jsx(ListItem, { children: "Third" }) })
    ] })
  ] });
}
export {
  GroupDemo
};
//# sourceMappingURL=GroupDemo.js.map
